export class VerificaCampanhaResponseDto {
    mensagem: string;
    autorizado: boolean;
    campanhaAtiva: boolean;
    realizouCampanha: boolean;
}

